module.exports = __webpack_public_path__ + "static/media/unionPoster.a1422678.png";